import React from 'react';
import { Link } from 'react-router-dom';
import Imageone from "../../images/Hand-tools/one.webp";
import Imagetwo from "../../images/Hand-tools/two.webp";
import Imagethree from "../../images/Hand-tools/three.webp";
import Imagefour from "../../images/Hand-tools/four.webp";
import Imagefive from "../../images/Hand-tools/five.webp";
import Imagesix from "../../images/Hand-tools/six.webp";
import Imageseven from "../../images/Hand-tools/seven.webp";
import Imageeight from "../../images/Hand-tools/eight.webp";
import Imagenine from "../../images/Hand-tools/nine.webp";
import Imageten from "../../images/Hand-tools/ten.jpg";
import Imageleven from "../../images/Hand-tools/eleven.webp";
import Imagetwelve from "../../images/Hand-tools/twelve.webp";

const tools = [
  { img: Imageone, name: "Pliers" },
  { img: Imagetwo, name: "Wrenches(Spanner)" },
  { img: Imagethree, name: "Screwdrivers" },
  { img: Imagefour, name: "Hammers" },
  { img: Imagefive, name: "Cutting Tools" },
  { img: Imagesix, name: "Clamps" },
  { img: Imageseven, name: "Caulking Gun" },
  { img: Imageeight, name: "Grease Gun" },
  { img: Imagenine, name: "Gunpla Nippers" },
  { img: Imageten, name: "Coping Saw" },
  { img: Imageleven, name: "Allen Key set" },
  { img: Imagetwelve, name: "Nut Wrench Set" },
];

function Coming() {
  return (
    <div className="py-6">
      <div className="bg-white rounded-xl">
        <div className="mx-auto px-4 py-10 sm:px-10 sm:py-14">
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            {tools.map((tool, index) => (
              <Link
                key={index}
                to="#"
                className="group block overflow-hidden rounded-2xl shadow-2xl hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-gradient-to-br from-white to-gray-50"
              >
                <div className="relative">
                  <img
                    src={tool.img}
                    alt={tool.name}
                    className="w-full h-64 object-cover transition-opacity duration-300 rounded-t-2xl"
                  />
                  <div className="px-4 py-3 text-center">
                    <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 group-hover:text-blue-600 transition duration-300 tracking-wide">
                      {tool.name}
                    </h3>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Coming;
